import { Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useState, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";

const BugReportModal = lazy(() => import("./BugReportModal"));

const BugReportButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  // Hide on admin pages
  if (location.pathname === "/admin/blog") {
    return null;
  }

  return (
    <>
      <div
        className="fixed bottom-6 left-6 z-50 animate-fade-in"
        style={{ animationDelay: "0.3s", animationFillMode: "backwards" }}
      >
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              aria-label="Zgłoś błąd"
              onClick={() => setIsModalOpen(true)}
              className="h-8 w-8 sm:h-12 sm:w-12 rounded-full glass-card border-white/20 hover:bg-white/20 shadow-lg"
            >
              <Bug className="h-3.5 w-3.5 sm:h-5 sm:w-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>Zgłoś błąd</p>
          </TooltipContent>
        </Tooltip>
      </div>

      {isModalOpen && (
        <Suspense fallback={null}>
          <BugReportModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </Suspense>
      )}
    </>
  );
};

export default BugReportButton;
